// Generated by purs version 0.13.8
"use strict";
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var TypeEnv = function (x) {
    return x;
};
var singleton = function (name) {
    return function (scheme) {
        return TypeEnv(Data_Map_Internal.singleton(name)(scheme));
    };
};
var semigroupTypeEnv = Data_Map_Internal.semigroupMap(Lunarbox_Data_Dataflow_Expression.ordVarName);
var newTypeTypeEnv = new Data_Newtype.Newtype(function (n) {
    return n;
}, TypeEnv);
var monoidTypeEnv = Data_Map_Internal.monoidMap(Lunarbox_Data_Dataflow_Expression.ordVarName);
module.exports = {
    TypeEnv: TypeEnv,
    singleton: singleton,
    newTypeTypeEnv: newTypeTypeEnv,
    semigroupTypeEnv: semigroupTypeEnv,
    monoidTypeEnv: monoidTypeEnv
};
